import getHostUrl from '../../src/lib/getHostUrl'

import api from './api'

const requestPasswordReset = (email: string): Promise<unknown> =>
    api<unknown>({
        method: 'PUT',
        path: '/auth/password/reset/request',
        query: { hosturl: getHostUrl() },
        body: { email },
    })

export default requestPasswordReset
